<template>
  <div>
    <v-row wrap>
      <v-col cols="12">
        <item-list
        v-if="showList"
        :endpoint="endpoint + 'endpoints/status'"
        :headers="headers"
        id="_id"
        :filter="filters"
        name="Endpoint Status"
        pagination
        permissions="endpoints"
        ></item-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'

import {ENDPOINT, DATEFORMATSTRING} from '@/shared/constants'
import ItemList from 'vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  data () {
    return {
      currentStatus: {},
      endpoint: ENDPOINT,
      statuses: [],
      headers: [
        {
          text: 'Time',
          value: 'time',
          function: this.formatTimeList,
          sortable: true
        },
        {
          text: 'Uptime',
          value: 'uptime',
          sortable: true
        },
        {
          text: 'Temperature',
          value: 'readerTemp',
          sortable: true
        },
        {
          text: 'IP',
          value: 'ip',
          sortable: true
        },
        {
          text: 'Version',
          value: 'version',
          sortable: true
        }
      ]
    }
  },

  computed: {
    filters: function () {
      return [{
        name: 'endpoint',
        value: this.$route.params.id
      }]
    },

    showList: function () {
      return this.$route.params.id !== 'new'
    }
  },

  methods: {
    formatTime: function (time) {
      if (time) {
        return moment(time).format(DATEFORMATSTRING + ' hh:mm:ss a')
      }
      return ''
    },

    formatTimeList: function (item) {
      return this.formatTime(item.time)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tabs/EndpointStatus.vue